module.exports = __webpack_public_path__ + "f0fe5acbace65071a9e57c8ebf715818.svg";